// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2LDiz","header":"ClearentDisclaimer_header__3q1ws","inner":"ClearentDisclaimer_inner__3pHdu"};